import { P, FF } from "../../styles/tokens";
import DukyChat from "./DukyChat";

export default function DukyPanel({
  open,
  onClose,
  month,
  mesId,
  totalIng,
  totalFij,
  totalExt,
  ahorroReal,
  activeMonth,
  metas,
  presupuestos,
  mobile,
  onNavigate,
}) {
  if (!open) return null;

  const panelStyle = mobile
    ? {
        position: "fixed",
        inset: 0,
        zIndex: 100,
        background: P.bg,
        display: "flex",
        flexDirection: "column",
      }
    : {
        position: "fixed",
        right: 24,
        bottom: 24,
        width: 380,
        height: "min(600px, calc(100vh - 48px))",
        zIndex: 100,
        background: P.surface,
        borderRadius: 24,
        border: `1.5px solid ${P.border}`,
        boxShadow: "0 20px 60px rgba(0,0,0,0.18), 0 8px 24px rgba(0,0,0,0.10)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      };

  return (
    <>
      {/* Backdrop */}
      {!mobile && (
        <div
          onClick={onClose}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 99,
            background: "rgba(0,0,0,0.15)",
          }}
        />
      )}

      <div style={panelStyle}>
        {/* Header */}
        <div
          style={{
            padding: "16px 18px",
            borderBottom: `1.5px solid ${P.border}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: P.surface,
            flexShrink: 0,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: 12,
                background: P.ingresos.base,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18,
              }}
            >
              🐿️
            </div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 800, color: P.text, fontFamily: FF }}>
                Duky
              </div>
              <div style={{ fontSize: 10, color: P.textXs, fontFamily: FF }}>
                Tu consejera financiera
              </div>
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              width: 32,
              height: 32,
              borderRadius: 10,
              border: `1.5px solid ${P.border}`,
              background: "transparent",
              color: P.textSm,
              cursor: "pointer",
              fontSize: 16,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: FF,
            }}
          >
            ✕
          </button>
        </div>

        {/* Chat body */}
        <div style={{ flex: 1, overflow: "hidden" }}>
          <DukyChat
            mesId={mesId}
            activeMonth={activeMonth}
            onClose={onClose}
          />
        </div>
      </div>
    </>
  );
}
